<template>
  <mdb-container>
    <div v-if="currentGroup && (mode=='group' || mode == 'member')">
      <banner-small :group="currentGroup" :title="pageTitle"/>
    </div>
    <div v-if="mode=='user'" class="gp-has-header text-left">
      <h5>My {{ capitalize($tc("common.label.event", 2)) }}</h5>
    </div>
    <div v-if="mode=='member' && currentGroup && member" class="text-left">
      <mdb-btn size="sm" rounded
               @click="$router.push('/group/' + currentGroup.vanityPath + '/members/' + member.id)"
               icon="arrow-left">{{ capitalize($tc("common.label.member", 1)) }} View
      </mdb-btn>
    </div>
    <div class="text-left">
      <mdb-input @input="isTyping = true"
                 placeholder="Search" type="text" v-model="eventQuery"
      >
        <span slot="prepend">
          <mdb-icon icon="search"/>

        </span>
        <span slot="append" class="small">
          <router-link :to="'/group/' + this.currentGroup.vanityPath + '/event-search'" v-if="mode=='group'">Advanced
          </router-link>
        </span>
      </mdb-input>

      <div v-if="eventQuery && searchResults.length==0 && !isTyping" class="text-left">
        <h4>No results found for "{{ eventQuery }}"</h4>
      </div>
    </div>

    <mdb-card v-if="searchResults.length>0" class="text-left">
      <mdb-card-header>
        <h5>Search Results ({{ totalFound }})</h5>
      </mdb-card-header>
      <mdb-card-body>
        <event-list :listData="searchResults" :mode="mode" :pagination="true" :totalCount="totalFound"
                    @loadMore="loadMoreFound"/>
      </mdb-card-body>
    </mdb-card>

    <div class="text-left" v-if="(eventData.future.length>0||eventData.past.length>0) && !eventQuery">
      <mdb-tabs :active="0" :links="tabLinks" :transition-duration="0.5" card
                class="mb-5"
                tabs
                transition-style="linear"
      >

        <div :slot="'Planned'">
          <event-list :listData="eventData.future" :pagination="true" :totalCount="eventData.meta.futureCount"
                      :mode="mode"
                      @loadMore="loadMoreFuture"/>
        </div>
        <div slot="Completed">
          <event-list :listData="eventData.past" :pagination="true" :totalCount="eventData.meta.pastCount"
                      :mode="mode"
                      @loadMore="loadMorePast"/>
        </div>
      </mdb-tabs>
    </div>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import utils from "../../services/utils";
import _ from 'lodash'
import bannerSmall from '../group/BannerSmall'
import eventList from '../event/List'
import {mapState} from 'vuex'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbIcon, mdbInput, mdbTabs,} from 'mdbvue';

export default {
  name: "group-events",
  components: {
    mdbBtn,
    mdbContainer,
    mdbIcon,
    mdbTabs,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    bannerSmall,
    mdbInput,
    eventList
  },
  computed: mapState({
                       currentGroup: state => state.currentGroup,
                       settings: state => state.settings
                     }),
  data() {
    return {
      isTyping: false,
      mode: null,
      eventsUrl: null,
      eventQuery: "",
      eventData: {
        future: [],
        past: [],
        meta: {},
      },
      searchResults: [],
      totalFound: 0,
      tabLinks: [{text: 'Planned'}, {text: 'Completed'}],
      member: null,
      pageTitle: ""
    }
  },
  watch: {
    eventQuery: _.debounce(function () {
      this.isTyping = false;
    }, 300),
    isTyping: function (value) {
      if (!value) {
        if (this.eventQuery) this.loadMore("search", 0)
        else this.searchResults = []
      }
    }
  },
  mounted() {
    this.pageTitle = utils.capitalize(this.$tc("common.label.event", 2))
    document.title = this.pageTitle
    this.$store.dispatch("setExecuting", true)

    if (this.$route.params.id) {
      if (this.$route.path.indexOf("/group") != -1) this.mode = "group"
      if (this.$route.path.indexOf("/member") != -1) this.mode = "member"
      this.eventsUrl = "/" + this.mode + "/events/" + this.$route.params.id
    } else {
      this.mode = "user"
      this.eventsUrl = "/user/events"
    }

    api.get(this.eventsUrl).then(
      (results) => {
        this.eventData.meta = results.data.meta;
        this.eventData.future = results.data.future;
        this.eventData.past = results.data.past;
        if (this.mode == "group" && (!this.currentGroup || this.currentGroup.id != this.eventData.meta.groupId)) {
          api.groupBasics(this.eventData.meta.groupId, "public");
        }
        if (this.mode == "member") {
          this.member = results.data.member
          this.pageTitle = "Events for " + this.member.name
          if (!this.currentGroup || this.currentGroup.id != this.member.groupId) {
            api.groupBasics(this.member.groupId, "member");
          }
        }
      },
      (error) => {
        if (error.response.status == 403) {
          this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
          return
        }
        this.$notify.error({message: error.response.data, timeOut: 20000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    loadMoreFuture(offset) {
      this.loadMore("future", offset)
    },
    loadMorePast(offset) {
      this.loadMore("past", offset)
    },
    loadMoreFound(offset) {
      this.loadMore("search", offset)
    },
    loadMore(version, offset) {
      this.$store.dispatch("setExecuting", true)
      let url = this.eventsUrl + "/?version=" + version + "&offset=" + offset
      if (version == "search") url += "&q=" + this.eventQuery
      api.get(url).then(
        (results) => {
          if (version == "future") this.eventData.future = results.data
          if (version == "past") this.eventData.past = results.data;
          if (version == "search") {
            this.searchResults = results.data.found
            this.totalFound = results.data.totalFound
          }
          let el = document.getElementsByClassName("tab-content")
          if (el && el.length > 0) {
            /*let style = el[0].getAttribute("style")
             console.log("Style is ",style)*/
            el[0].setAttribute("style", "")  //remove previously calculated height; mdb-tab doesn't resize with content!
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>

